function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CanadaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4530",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18,
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4530)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 3H18.75V21H6V3Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.7467 9.30191L11.9798 7.5L12 18H11.4861L11.8014 15.4015C11.8014 15.4015 8.34268 16.0369 8.62862 15.7164C8.91455 15.3959 9.07925 14.8081 9.07925 14.8081L6 12.7109C6 12.7109 6.48573 12.7047 6.88088 12.4648C7.27604 12.2249 6.48573 10.802 6.48573 10.802L8.0404 11.0329L8.62862 10.3803L9.80159 11.6335H10.3289L9.80159 8.763L10.7467 9.30191ZM12 18V7.5L13.2533 9.30191L14.1984 8.763L13.6711 11.6335H14.1984L15.3714 10.3803L15.9596 11.0329L17.5143 10.802C17.5143 10.802 16.724 12.2249 17.1191 12.4648C17.5143 12.7047 18 12.7109 18 12.7109L14.9207 14.8081C14.9207 14.8081 15.0854 15.3959 15.3714 15.7164C15.6573 16.0369 12.1986 15.4015 12.1986 15.4015L12.5139 18H12Z",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 3H24V21H18V3Z",
      fill: "#E31D1C"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H6V21H0V3Z",
      fill: "#E31D1C"
    })]
  })]
}));
//# sourceMappingURL=Canada.js.map